import type { ChatIdMark, DividerMark, NewsMark } from '@/engine/ChatEngine/ChatEngineTypes'
import { ChatMarks } from '@/engine/ChatEngine/constants'

export const isChatIdMark = (mark: string | null | undefined): mark is ChatIdMark => {
  return !!mark?.startsWith(`${ChatMarks.Chat}:`)
}

export const  isDividerId = (mark: string | null | undefined): mark is DividerMark => {
  return !!mark?.startsWith(`${ChatMarks.Divider}:`)
}

export const isNewsMark = (mark: string | null | undefined): mark is NewsMark => {
  return !!mark?.startsWith(`${ChatMarks.News}:`)
}
